import { element, IDirective, IDocumentService } from 'angular';

import { checkToKeepping } from '../../../helpers/check-to-keeping';
import './ng.custom.select.sass';

export function ngCustomSelectDirective( $document: IDocumentService ): IDirective {
  return {
    restrict: 'E',
    template: require('./ng.custom.select.pug')(),
    scope: {
      options: '=',
      isGroupSelect: '=',
      result: '=ngModel',
      required: '=',
      disabled: '=',
      readonly: '='
    },
    link: function postLink( $scope: any, $element, $attributes ) {
      $scope.showListFlag = false;
      $scope.showError = false;
      $scope.selected = '';

      const scopeExpression = $attributes.outsideClick;
      const onDocumentClick = ( event ) => {
        console.log('custom select', event);
        event.preventDefault();

        if ( checkToKeepping($element, event.toElement) ) {
          return;
        } else {
          $scope.showListFlag = false;
          if ( $scope.required ) {
            $scope.showError = !$scope.result || !($scope.result.length > 0);
          }
          $document.off('click', onDocumentClick);
          $scope.$apply(scopeExpression);
        }
      };

      const buttonClick = ( $event ) => {
        $event.preventDefault();
        $scope.$apply(() => {
          $scope.showListFlag = !$scope.showListFlag;
          if ( $scope.showListFlag ) {
            $document.on('click', onDocumentClick);
          } else {
            $document.off('click', onDocumentClick);
          }
        });
      };

      $scope.setCustomValue = () => {
        if ( !$scope.isGroupSelect ) {
          $scope.result = $scope.selected;
        }
      };

      $scope.selectItem = ( $event, item ): void => {
        const elem = $event.currentTarget;
        const elemValue = elem.innerHTML;

        if ( $scope.isGroupSelect ) {
          $scope.result = item.id;
          $scope.selected = item.name;
        } else {
          $scope.result = item;
          $scope.selected = item;
        }
        $scope.showListFlag = false;
      };

      element($element[ 0 ].querySelector('.block-select-as')).on('click', buttonClick);
      $scope.$watch('result', () => {
        if ( !$scope.isGroupSelect ) {
          $scope.selected = $scope.result;
        }
      });
    }
  };
}

ngCustomSelectDirective.$inject = [ '$document' ];



// WEBPACK FOOTER //
// ./app/shared/directives/ng.custom.select/ng.custom.select.directive.ts